import * as React from "react";
import EntryRow from "./EntryRow";
import * as utils from "../utils";
import {Col, Row} from "react-bootstrap";

export default class EntryTable extends React.Component{
    render(){

        const {entries, clients, tasks, projects, hide, users, activeUser, empty, showTeam} = this.props;

        let totalMinutes = 0;
        const filteredEntries = entries ? entries.filter(entry => showTeam || entry.user.id === activeUser.id) : [];

        // if(filteredEntries.length === 0) return this.props.children;

        const showAll = !hide || hide.length === 0;

        return filteredEntries.length > 0 ? ([
            <Row key="head" className="entry-table-head hidden-xs">
                {(!hide || !hide.includes("project")) && <Col sm={2} className="project">Project</Col>}
                <Col sm={4 - (showTeam ? 1 : 0) - (showAll ? 1 : 0)} className="task">Task</Col>
                {showTeam && (
                    <Col sm={2} className="user">Member</Col>
                )}
                {(!hide || !hide.includes("date")) && <Col sm={2 - (showAll ? 1 : 0)} className="date">Date</Col>}
                <Col sm={4 - (showTeam ? 1 : 0)} className="description">Description</Col>
                <Col sm={2} className="hours" style={{textAlign: "right"}}>Hours</Col>
            </Row>,
            <div key="body" className="entry-table-body">
                {filteredEntries.map((entry, id) => {
                    totalMinutes += entry.minutes;
                    return <EntryRow key={entry.id}
                                     entry={entry}
                                     client={clients.items[entry.client.id]}
                                     task={tasks.items[entry.task.id]}
                                     project={projects.items[entry.project.id]}
                                     user={users.items[entry.user.id]}
                                     userIsSelf={entry.user.id === activeUser.id}
                                     hide={this.props.hide}
                                     showUser={showTeam}
                                     onItemClick={this.props.onItemClick}
                                     editingEntry={this.props.editingEntry}
                    />
                })}
            </div>,
            <Row key="footer" className="entry-table-footer">
                <Col sm={12} style={{textAlign: "right"}}>
                    <span style={{color: "#bbb", fontSize: "10pt"}} className="visible-xs">total {utils.formatHours(totalMinutes)}</span>
                    <span style={{color: "#bbb", fontSize: "10pt"}} className="hidden-xs">{utils.formatHours(totalMinutes)} total</span>
                </Col>
            </Row>
        ]) : (
            <Row className="entry-table-no-entries">
                <Col sm={12} style={{textAlign: "center"}}><em>{empty}</em></Col>
            </Row>
        );
    }
}

// export default connect()(EntryTable)


// WEBPACK FOOTER //
// ./src/components/EntryTable.js